__turbopack_context__.v({
  "select-input-box": "OxasLa_select-input-box",
});
